<script>
  export let keywords;
  export let placeholder;

  import Keyword from "./Keyword.svelte";

  import { dictionary } from "../utils/stores.js";

  let dict;

  const unsubscribe = dictionary.subscribe(value => {
    dict = value;
  });

  let keyword = "";

  let anadirPalabraClave = () => {
    if (keyword !== "") {
      const pos = keywords.findIndex(item => {
        return item.toUpperCase() === keyword.toUpperCase();
      });
      if (pos === -1) {
        keywords.push(keyword);
        keywords = keywords;
      }
      keyword = "";
    }
  };

  let eliminarPalabraClave = index => {
    keywords.splice(index, 1);
    keywords = keywords;
  };
</script>

<style>
  div.keywords {
    display: flex;
    width: 100%;
    align-items: center;
    margin-bottom: 20px;
  }

  div.keywords div.form-wrap {
    margin-top: 0px;
  }

  div.keywords input {
    min-width: 450px;
  }

  div.botonAnadir {
    margin-left: 20px;
  }

  div.keywordList {
    display: flex;
    margin-bottom: 20px;
    flex-wrap: wrap;
  }
</style>

{#if keywords.length < 5}
  <div class="keywords">
    <div class="form-wrap">
      <input
        class="form-input"
        {placeholder}
        type="text"
        maxlength="50"
        bind:value={keyword} />
    </div>
    <div class="form-wrap">
      <div
        class="button button-sm button-primary botonAnadir"
        on:click={() => anadirPalabraClave()}>
        {dict['anadir']}
      </div>
    </div>
  </div>
{/if}
<div class="keywordList">
  {#each keywords as keyword, index}
    <Keyword {keyword} onRemove={() => eliminarPalabraClave(index)} />
  {/each}
</div>
